<template>
  <div class="animated fadeIn">
    <b-card v-if="show">
      <template slot="header"><i class='fa fa-align-justify'></i> Schedules List</template>

      <b-row>
        <b-col sm="6">
          <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
            Show Count
            <select v-model="so.perPage" @change="refresh">
              <option disabled value="15">Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>

        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'search'"  size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='site.fqdn';so.skt='FQDN'">FQDN</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='site.name';so.skt='Name'">Name</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          * <b-badge variant="warning">Notice</b-badge>
          : For site availability, you can perform a maximum of three checks a day.
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="group" slot-scope="row">{{row.item.group ? row.item.group.groupname : '-'}}</template>
        <template slot="fqdn" slot-scope="row">{{row.item.site.fqdn}}</template>
        <template slot="name" slot-scope="row">
          <del v-if="row.item.site.is_del">{{row.item.site.name}}</del>
          <template v-else>{{row.item.site.name}}</template>
        </template>
        <template slot="last_time" slot-scope="row">{{row.item.last_time | utcsdate}}</template>
        <template slot="due_time" slot-scope="row">{{row.item.due_time | utcdatetime }}</template>
        <template slot="func" slot-scope="row">
          <b-btn :disabled="row.item.is_starting" @click="action('delay', row.item)" size="sm" variant="warning">Delay</b-btn>
          <b-btn :disabled="row.item.is_starting" @click="action('start', row.item)" size="sm" variant="danger">Start</b-btn>
          <b-btn @click="action('result', row.item)" size="sm" variant="primary">Recent Result</b-btn>
          <b-btn @click="action('site', row.item)" size="sm" variant="success">Site</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Api } from '@/service';
import  codes from '@/codes';

export default {
  data: () => {
    return {
      confirm: undefined,
      selected: undefined,
      show: true,
      group : {},
      start : false,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
    }
  },
  computed: {
    fields (){ return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'group', label: 'Group', sortable: false },
        { key: 'site.fqdn', label: 'FQDN', sortable: false },
        { key: 'site.name', label: 'Name', sortable: false },
        { key: 'last_time', label: 'Last Time', sortable: true },
        { key: 'due_time', label: 'Next Time', sortable: true },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 25%'  },
      ]
    },
    rowCount() { return this.so.totalRows || 0; },
    startRow () { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {
    action(cmd = 'start', item) {
      switch (cmd) {
        case 'result':
          this.$router.push({ name: 'wmds_result', params: { site_id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'site':
          this.$router.push({ name: 'wmds_site', params: { id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'delay':
        case 'start':
          item.is_starting = true
          Api.Manager({ target : 'wmds.schedule', cmd : cmd, body : { site_id : item.site_id } }).then(rs => {
            rs.error ? this.$toastr.w("failed", "custom ", cmd, " failed") : this.$toastr.s("done", "request", cmd)
          }).then(() => this.refresh()).catch(e => { this.$toastr.e(e.data ? e.data.message : e) })
          break;
      }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.$refs._list.refresh();},
    refresh() { this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    remove() {
      try{
        Api.Manager_Call('wmds.schedule', 'delete', { id : this.selected.id })
        this.refresh(); this.$toastr.i('Schedule Remove Completion');
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
    },
    load(ctx = {}) {
      let so = {
        target : 'wmds.schedule', cmd : 'list',
        body : { sort : [ { name : 'id', op : 'desc' } ], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim() && this.so.sk) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return Api.Manager(so).then(rs => {
        if(rs.error) { return this.$$toastr.e("can't not load schedule") }
        this.so.totalRows = rs.total;
        (rs.body || []).forEach(r => r.is_starting = false);
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    hideList(e) { this.show = !e; console.log('schedule.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created() { console.log('schedule.list.vue', 'created'); },
  destroyed() { console.log('schedule.list.vue', 'destroyed'); },
  mounted() {
    console.log('schedule.list.vue', 'mounted');
    try { this.start = location.hostname == "localhost" || location.hostname == "console.f1secaas.net"; } catch { this.start = false; }
  },
}
</script>
